import { List,Record } from "immutable";

import createFromJS from "../createFromJS";

export const ItemPasteResultRecord = Record({
  success: true,
  errorMessage: null,
  actions: List(),
  items: [] // [Map]
});

const data = {};
createFromJS.registerCallback("ItemPasteResultRecord", createFromJS.createNestedCallback(ItemPasteResultRecord, data));
